module.exports = __webpack_public_path__ + "static/media/8base-logo-red-black.2c2ad8f9.svg";